import React from "react";
import routes from "./routes_paths.js";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import App from "./App";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles, CircularProgress } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import {
  getAccount,
  setNewLang,
  getTermsVersion,
  fetchInstitution,
} from "./actions/index";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { images } from "./utils/images";
import "react-toastify/dist/ReactToastify.min.css";

import FirstScreen from "./containers/FirstScreen";
import LoginScreen from "./containers/LoginScreen.js";
import SettingsContainer from "./containers/SettingsContainer";
import VerificationScreen from "./containers/VerificationScreen";
import SignUpContainer from "./containers/SignUpContainer.js";
import UpgradeContainer from "./containers/UpgradeContainer.js";
import CorporateContainer from "./containers/CorporateContainer";
import PasswordResetContainer from "./containers/PasswordResetContainer";
import NotFoundContainer from "./containers/NotFoundContainer";

import NotificationCenter from "./components/NotificationCenter";
import * as Auth from "./utils/auth";

const langs = [
  { name: "English", val: "en" },
  { name: "Spanish", val: "es" },
];

class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      langSelectorOpen: false,
    };

    this.changeLanguage = this.changeLanguage.bind(this);
  }

  async componentDidMount() {
    window.recaptchaOptions = {
      useRecaptchaNet: true,
    };

    // check if the user has a token in localStorage
    const hasValidToken = Auth.hasValidToken();

    if (!hasValidToken) {
      console.log("2lg");
      if (
        this.props.location.pathname !== "/id/login" &&
        window.location.pathname !== "/id/signup"
      ) {
        this.props.history.push("/id/login");
      }
    } else {
      console.log("3lg");

      await this.props.getAccount();
      // await this.props.fetchInstitution();

      // if the user is root domain
      if (this.props.location.pathname === "/") {
        this.props.history.push("/id/settings");
      }

      // if user is in login page or signup page, redirect to dashboard
      if (
        this.props.location.pathname === "/id/login" ||
        window.location.pathname === "/id/signup"
      ) {
        this.setState({ loading: true });
        Auth.redirectToDashboard();
      }
    }
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.lang, this.props.lang)) {
      this.props.i18n.changeLanguage(this.props.lang);
    }
  }

  // Change language
  changeLanguage = (newLang) => {
    this.setState({ langSelectorOpen: false });
    this.props.setNewLang(newLang);
  };

  render() {
    return (
      <App>
        <Switch>
          <Route exact path={routes.login} children={withRouter(LoginScreen)} />
          <Route
            exact
            path={routes.signup}
            children={withRouter(SignUpContainer)}
          />
          <Route
            exact
            path={routes.verification}
            children={withRouter(VerificationScreen)}
          />
          <Route
            exact
            path={routes.upgrade}
            children={withRouter(UpgradeContainer)}
          />
          <Route
            exact
            path={routes.settings}
            children={withRouter(SettingsContainer)}
          />
          {/* <Route
            exact
            path={routes.corporate}
            children={withRouter(CorporateContainer)}
          /> */}
          <Route
            exact
            path={routes.password_reset}
            children={withRouter(PasswordResetContainer)}
          />
          <Route component={withRouter(NotFoundContainer)} />
        </Switch>
        <NotificationCenter />
        <ToastContainer style={{ zIndex: 20000 }} autoClose={5000} />

        {/* <div style={{ position: "relative", width: "100%" }}>
          <div className={classes.selectLang}>
            <label>{t("selectLanguage")}:</label>
            <div className="languageSelector">
              <div
                className="selectorBtn"
                onClick={() =>
                  this.setState({ langSelectorOpen: !langSelectorOpen })
                }>
                <p>{lang.toUpperCase()}</p>
                {langSelectorOpen ? <ExpandMore /> : <ExpandLess />}
              </div>
              {langSelectorOpen ? (
                <div className="languagesContainer">
                  {langs.map((l, idx) => {
                    return (
                      <p
                        key={idx}
                        className={lang === l.val ? "activeLang" : ""}
                        onClick={() => this.changeLanguage(l.val)}>
                        {l.name}
                      </p>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div> */}
      </App>
    );
  }
}

function mapStateToProps(state) {
  return {
    account: state.account,
    lang: state.lang,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAccount,
      setNewLang,
      fetchInstitution,
    },
    dispatch
  );
}

const styles = (theme) => {
  return {
    loadingScreen: {
      // background: "#F5F6F8",
      // background: "rgb(38, 38, 38)",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      "& .logos": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& img": {
          width: 150,
          marginBottom: 32,
          marginLeft: 8,
          marginRight: 8,
        },
      },
      "& svg": {
        color: "#00d3cc",
      },
    },
    loadingScreenSolo: {
      // background: "#F5F6F8",
      background: "rgb(38, 38, 38)",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      "& .logos": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& img": {
          width: 150,
          marginBottom: 32,
          marginLeft: 8,
          marginRight: 8,
        },
      },
      "& svg": {
        color: "#D81D3C",
      },
    },
    soloLogo: {
      marginTop: 40,
      width: "100%",
      height: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      position: "relative",
      "& img": {
        width: 150,
        height: "auto",
      },
    },
    blackOverlay: {
      position: "absolute",
      top: 60,
      zIndex: 199,
      left: 0,
      height: 0,
      width: "100%",
      background: "black",
      opacity: 0.5,
      transition: ".3s",
    },

    selectLang: {
      display: "flex",
      alignItems: "center",
      color: "#C3C3C3",
      marginTop: 12,
      marginBottom: 12,
      marginLeft: "2.5%",
      "& label": {
        marginRight: 8,
      },

      "& .languageSelector": {
        position: "relative",
        "& .languagesContainer": {
          position: "absolute",
          bottom: 0,
          transform: "translate(-70%, 125%)",
          background: "#2E2E2E",
          borderRadius: 4,
          width: 100,
          "& p": {
            height: 20,
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            transition: ".3s",
            padding: "0 4px",
            "&:hover": {
              background: "#262626",
            },
            "&.activeLang": {
              background: "#D81D3C",
              cursor: "default",
              "&:hover": {
                background: "#D81D3C",
              },
            },
          },
        },
        "& .selectorBtn": {
          display: "flex",
          alignItems: "center",
          "& svg": {
            fontSize: 16,
          },
        },
      },
    },
  };
};

export default withRouter(
  withStyles(styles)(
    withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Routes))
  )
);
